export default __webpack_public_path__ + "images/STEWISLAND.4b0eebf.png";